export enum STATUS {
	UNSTARTED = 'unstarted',
	LOADING = 'loading',
	SUCCESS = 'success',
	ERROR = 'error',
}
